export default __webpack_public_path__ + "static/media/landing-agent-feature-6.d04810b4.svg";